
import { IonApp, IonContent, IonIcon, IonItem, IonLabel, IonList, IonListHeader, IonMenu, IonMenuToggle, IonNote, IonRouterOutlet, IonSplitPane, useIonRouter } from '@ionic/vue';
import { defineComponent } from 'vue';
import { useRoute } from 'vue-router';
import { homeOutline, homeSharp, carOutline, carSharp, gridOutline, gridSharp,logOutOutline,logOutSharp, personAddOutline, personAddSharp, readerOutline, readerSharp, cogOutline, cogSharp } from 'ionicons/icons';
import { userProfile,logout } from '@/services/AuthService'

export default defineComponent({
  name: 'App',
  components: {
    IonApp, 
    IonContent, 
    IonIcon, 
    IonItem, 
    IonLabel, 
    IonList, 
    IonListHeader, 
    IonMenu, 
    IonMenuToggle, 
    IonNote, 
    IonRouterOutlet, 
    IonSplitPane,
  },
  setup() {
    const ionRouter = useIonRouter();

    const signOut = () => {
      logout();
      ionRouter.navigate('/home','root');
    }
    const route = useRoute();
    
    return {
      userProfile,
      homeOutline,
      homeSharp,
      gridOutline,
      gridSharp,
      carOutline,
      carSharp,
      logOutOutline,
      logOutSharp,
      personAddOutline,
      personAddSharp,
      readerOutline,
      readerSharp,
      cogOutline,
      cogSharp,
      signOut,
      isSelected: (url: string) => url === route.path ? 'selected' : ''
    }
  }
});
